import { match } from "ts-pattern";

import { PackSort } from "./PackSort";

export const PackSortLabel: React.FC<{ sort: PackSort }> = ({ sort }) => {
  return (
    <>
      {match(sort)
        .with(PackSort.MostBookmarked, () => "Most bookmarked")
        .with(PackSort.MostPlayed, () => "Most played")
        .with(PackSort.WordCount, () => "Number of words")
        .with(PackSort.Recent, () => "Recently updated")
        .exhaustive()}
    </>
  );
};
